import MDBox from "components/Basics/MDBox";
import MDTypography from "components/Basics/MDTypography";
import {
	Checkbox,
	FormControl,
	FormControlLabel,
	Grid,
	InputLabel,
	MenuItem,
	Select
} from "@mui/material";
import InputDelay from "components/Custom/LittleForm/Inputs/InputDelay";

const UNIT_OPTIONS = [
	{ key: "showDays", label: "Jours" },
	{ key: "showHours", label: "Heures" },
	{ key: "showMinutes", label: "Minutes" },
	{ key: "showSeconds", label: "Secondes" }
];

/**
 * Right pannel to configure a delay field
 * @param {*} param0
 * @returns
 */
const PannelDelay = ({ values, handleInputChange }) => {
	const config = values?.config || {};

	const updateConfig = patch => {
		handleInputChange({
			target: {
				name: "config",
				value: { ...config, ...patch }
			}
		});
	};

	return (
		<MDBox display="flex" flex="1">
			<div style={{ borderLeft: "1px solid #ccc", height: "100%", margin: "0 10px" }} />
			<MDBox display="flex" flexDirection="column" width="100%">
				<MDBox sx={{ mb: 1 }}>
					<MDTypography variant="h6">Parametrer le delay</MDTypography>

					<MDBox mt={2}>
						<MDTypography variant="body2" fontWeight="bold">
							Unités affichées
						</MDTypography>
						<MDBox display="flex" flexWrap="wrap">
							{UNIT_OPTIONS.map(({ key, label }) => (
								<FormControlLabel
									key={key}
									control={
										<Checkbox
											checked={config[key] !== false}
											onChange={e => updateConfig({ [key]: e.target.checked })}
										/>
									}
									label={label}
								/>
							))}
						</MDBox>
					</MDBox>

					<MDBox mt={2}>
						<FormControl fullWidth>
							<InputLabel id="select-display-mode-label">Mode d&apos;affichage</InputLabel>
							<Select
								labelId="select-display-mode-label"
								label="Mode d'affichage"
								value={config.displayMode || "fields"}
								onChange={e => updateConfig({ displayMode: e.target.value })}
							>
								<MenuItem value="fields">Champs numériques</MenuItem>
								<MenuItem value="compact">Lecture seule (texte)</MenuItem>
							</Select>
						</FormControl>
					</MDBox>

					<MDBox mt={2}>
						<Grid container spacing={1}>
							<InputDelay
								label="Valeur par défaut"
								value={config.defaultValue || 0}
								onChange={ms => updateConfig({ defaultValue: ms })}
								item={{}}
							/>
						</Grid>
					</MDBox>

					<MDBox mt={2}>
						<Grid container spacing={1}>
							<InputDelay
								label="Minimum"
								value={config.min || 0}
								onChange={ms => updateConfig({ min: ms })}
								item={{}}
							/>
						</Grid>
					</MDBox>

					<MDBox mt={2}>
						<Grid container spacing={1}>
							<InputDelay
								label="Maximum"
								value={config.max || 0}
								onChange={ms => updateConfig({ max: ms })}
								item={{}}
							/>
						</Grid>
					</MDBox>
				</MDBox>
			</MDBox>
		</MDBox>
	);
};

export default PannelDelay;
